import { forwardRef, useMemo, InputHTMLAttributes } from 'react';

import { defaults } from '@hh.ru/magritte-common-number-formatter';
import { Input } from '@hh.ru/magritte-ui-input/Input';
import { numberFormatterFactory } from '@hh.ru/magritte-ui-input/numberFormatter';
import { ControlledNumberInputProps } from '@hh.ru/magritte-ui-input/types';

export const NumberInput = forwardRef<
    HTMLInputElement,
    ControlledNumberInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof ControlledNumberInputProps>
>(
    (
        {
            groupSeparator = defaults.groupSeparator,
            decimalMark = defaults.decimalMark,
            groupSize = defaults.groupSize,
            decimalLength = defaults.decimalLength,
            allowNegative = defaults.allowNegative,
            ...restProps
        },
        ref
    ) => {
        const numberFormatter = useMemo(() => {
            return numberFormatterFactory({ groupSeparator, decimalMark, groupSize, decimalLength, allowNegative });
        }, [groupSeparator, decimalMark, groupSize, decimalLength, allowNegative]);

        return <Input {...restProps} inputMode="decimal" formatter={numberFormatter} ref={ref} />;
    }
);

NumberInput.displayName = 'NumberInput';
